import React, { memo } from 'react';
import { OrdersTableProps } from '../Monitor.types';
import { findPickupInstructionsGroup } from '../../../../utils/bundlesMonitorUtils';
import { OrderBundle } from 'components/OrderBundle/OrderBundle';
import { Paper } from '@material-ui/core';

const MonitorOrdersTable = memo(
  ({
    bundle,
    currentOrdersInstructions,
    onSelectOrderInstruction,
    onSaveDndDraft,
  }: OrdersTableProps): JSX.Element => {
    const pickupsGroup = findPickupInstructionsGroup(currentOrdersInstructions);
    return (
      <Paper key={`order-bundle-${bundle.id}`}>
        <OrderBundle
          hasSearch
          hasDragAndDrop
          hasCheckbox
          defaultOrderInstructions={currentOrdersInstructions}
          columns={[
            'InstructionType',
            'OrderNumber',
            'Pin',
            'Address',
            'Customer',
            'TemperatureOrder',
            'WindowTime',
            'Diff',
            'EstimateTimeArrival',
            'NewEstimateTimeArrival',
            'Done',
          ]}
          bundle={bundle}
          pickupsGroup={pickupsGroup}
          onSelectOrderInstruction={onSelectOrderInstruction}
          onSaveDndDraft={onSaveDndDraft}
        />
      </Paper>
    );
  }
);

MonitorOrdersTable.displayName = 'MonitorOrdersTable';
MonitorOrdersTable.whyDidYouRender = true;
export { MonitorOrdersTable };
